export default __webpack_public_path__ + "static/media/PlatinumCard1.1f852cea.png";